import Body from '../Body/Body';
import SectionHeader from '../SectionHeader/SectionHeader';
import { PlaceholderKjoreGaar } from '../SVGs/Placeholder';
import SvgIllustration from '../Illustration/SvgIllustration';
import HotspotImage from '../PageElements/HotspotImage';
import { RichText, Image as ValImage } from '@valbuild/next';

export interface TxtBoxProps {
  title?: string;
  imageRef?: ValImage;
  text: RichText<{
    block: {
      h1: true;
      h2: true;
      h3: true;
      h4: true;
      h5: true;
      h6: true;
      ul: true;
      ol: true;
    };
    inline: {
      a: true;
      img: true;
    };
    style: {
      bold: true;
      italic: true;
      lineThrough: true;
    };
  }>;
  alt?: string;
  removeImageEffect?: boolean;
  rightSide?: boolean;
}

const TxtBox = ({
  title,
  imageRef,
  alt,
  text,
  removeImageEffect = false,
  rightSide = false,
}: TxtBoxProps) => {
  return (
    <div
      className={`flex text-blank-black selection:text-blank-yellow ${
        rightSide ? 'laptop:flex-row-reverse' : 'laptop:flex-row'
      } flex-col gap-y-32`}
    >
      {imageRef ? (
        <div
          className={`flex flex-col relative max-w-[649px] max-h-[649px] aspect-portrait tablet:aspect-square laptop:aspect-square laptop:min-w-[649px]`}
        >
          <HotspotImage
            alt={alt}
            className={`${
              removeImageEffect && 'opacity-[0.85] mix-blend-multiply'
            }`}
            image={imageRef}
          />
        </div>
      ) : (
        <SvgIllustration
          className={`flex flex-col ${
            rightSide && 'self-end'
          } max-w-[320px] tablet:max-w-[500px] laptop:max-w-[649px]`}
        >
          <PlaceholderKjoreGaar />
        </SvgIllustration>
      )}

      <div
        className={`flex flex-col relative bg-blank-yellow z-10 laptop:w-[560px] max-w-[560px] laptop:mt-10 laptop:p-32 transition-bg-1s h-fit ${
          rightSide ? 'laptop:-right-[80px]' : 'laptop:-left-[80px]'
        }`}
      >
        {title && (
          <>
            <SectionHeader
              variant="plakat-smaller"
              className="text-left break-words"
            >
              {title}
            </SectionHeader>
            <br />
          </>
        )}
        {typeof text === 'string' ? (
          <Body>{text}</Body>
        ) : (
          <Body richText={text} />
        )}
      </div>
    </div>
  );
};

export default TxtBox;
